import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import {
  HeroLanding,
  CoursesReview,
  CourseReviewCard,
  CourseBenefits,
  CourseCheckoutForm
} from '@components';
import Custom404 from '../404';

const BASE_PACKAGES = {
  'online-cursussen-basis': {
    title: 'Basispakket',
    introText:
      'Groei vol vertrouwen naar het ouderschap met het basispakket van cursusportaal. Van eerste schopjes tot eerste ontmoeting. 8 cursussen in één pakket.',
    benefits: [
      'Inzichten van experts',
      '12 maanden onbeperkt toegang',
      '8 cursussen voor één prijs',
      'Te volgen waar en wanneer jij wil',
      <div>
        Vaak (deels){' '}
        <a href="/verzekering/cursus-vergoeding" target="_blank">
          vergoed
        </a>{' '}
        door je zorgverzekering
      </div>
    ],
    price: '99,95'
  },
  'online-cursussen-plus': {
    title: 'Pluspakket',
    introText:
      'Groei vol vertrouwen naar het ouderschap met het pluspakket van cursusportaal. Van eerste schopjes tot eerste ontmoeting. 17 cursussen in één pakket.',
    benefits: [
      'Inzichten van experts',
      '18 maanden onbeperkt toegang',
      '17 cursussen voor één prijs',
      'Te volgen waar en wanneer jij wil',
      <div>
        Vaak (deels){' '}
        <a href="/verzekering/cursus-vergoeding" target="_blank">
          vergoed
        </a>{' '}
        door je zorgverzekering
      </div>
    ],
    price: '139,95'
  },
  'online-cursussen-pro': {
    title: 'Pro-pakket',
    introText:
      'Groei vol vertrouwen naar het ouderschap met het pro-pakket van cursusportaal. Van eerste schopjes tot eerste ontmoeting. 17 cursussen in één pakket.',
    benefits: [
      'Inzichten van experts',
      '36 maanden onbeperkt toegang',
      '17 cursussen voor één prijs',
      'Te volgen waar en wanneer jij wil',
      <div>
        Vaak (deels){' '}
        <a href="/verzekering/cursus-vergoeding" target="_blank">
          vergoed
        </a>{' '}
        door je zorgverzekering
      </div>
    ],
    price: '179,95'
  },
  'online-cursussen-babypakket': {
    title: 'Babypakket',
    introText:
      'Groei vol vertrouwen in het ouderschap. Van eerste ontmoeting en veilige hechting, tot doorslapen en samen ontspannen. 12 babycursussen, voordelig in één pakket.',
    benefits: [
      'Inzichten van experts',
      '18 maanden onbeperkt toegang',
      '12 cursussen voor één prijs',
      'Te volgen waar en wanneer jij wil'
    ],
    price: '59,95'
  }
};

const PACKAGES = {
  ...BASE_PACKAGES,
  'online-cursussen-offer1': {
    ...BASE_PACKAGES['online-cursussen-plus'],
    price: '89,95'
  },
  'online-cursussen': {
    ...BASE_PACKAGES['online-cursussen-plus'],
    price: '99,95'
  }
};

function parsePriceToRevenue(price) {
  const num = Number(String(price).replace(',', '.').trim());
  return Number.isFinite(num) ? num : undefined;
}

export default function Page(props) {
  const router = useRouter();
  const pkgName = router.query.package;
  const pkgData = PACKAGES[pkgName];

  useEffect(() => {
    if (typeof window === 'undefined' || !router.isReady || !pkgData) {
      return;
    }

    const revenue = parsePriceToRevenue(pkgData.price);
    if (revenue == null) return;

    try {
      localStorage.setItem('courseRevenue', String(revenue));
      localStorage.setItem('coursePackage', String(pkgName || ''));
    } catch (e) {}
  }, [router.isReady, pkgName, pkgData]);

  if (!pkgData) return <Custom404 {...props} />;

  return (
    <>
      <Head>
        <title>Zwangerschapscursus</title>
      </Head>

      <div className="checkoutLayout-hero">
        <HeroLanding.Intro
          title={pkgData.title}
          content={() => <p>{pkgData.introText}</p>}
          imageSrc={require('@assets/images/courses/afbeelding-afrekenen.webp')}
          imageAlt="zwangerschaps- en babycursussen"
        />
      </div>

      <div className="checkoutLayout">
        <div className="checkoutLayout-left">
          <CourseBenefits
            title="Voordelen van Cursusportaal"
            items={pkgData.benefits}
          />
          <CourseReviewCard
            title="Meer vertrouwen"
            text="Door de zwangerschapscursus van cursusportaal heb ik meer vertrouwen gekregen in het proces van de zwangerschap. Hierdoor voel ik mij minder onzeker en kan ik meer genieten."
          />
        </div>

        <div className="checkoutLayout-right">
          <CourseCheckoutForm
            pkg={{ ...pkgData, name: pkgName }}
            addUserEvent={props.addUserEvent}
          />
        </div>
      </div>

      <CoursesReview />
    </>
  );
}
